import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Y si no tengo experiencia?',
  answer: 'Perfecto. Este sistema está hecho para empezar sin experiencia. Usamos habilidades que ya tienes o que puedes aprender en minutos.'
}, {
  question: '¿Y si no tengo tiempo?',
  answer: 'El plan está pensado para 30–60 minutos al día. No más. Está diseñado para gente ocupada con trabajo y familia.'
}, {
  question: '¿Y si me da pena vender?',
  answer: 'Por eso tienes guiones. No improvisas. Solo sigues el texto que ya funciona para responder y cerrar sin sentirte incómodo.'
}, {
  question: '¿Esto funciona en USA en español?',
  answer: 'Sí: Marketplace, WhatsApp y comunidades locales son perfectas para hispanohablantes en Estados Unidos.'
}, {
  question: '¿Es un curso largo?',
  answer: 'No. Es un PDF de acción directa. No hay videos de 2 horas. Lees, aplicas y ejecutas el mismo día.'
}];
export function FAQSection() {
  return <section className="py-20 px-4 max-w-2xl mx-auto" data-id="element-70">
      <h2 className="font-display text-4xl font-bold text-center text-white mb-12" data-id="element-71">
        Preguntas Frecuentes
      </h2>
      <div className="space-y-4" data-id="element-72">
        {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-73" />)}
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-800 rounded-lg bg-brand-surface overflow-hidden" data-id="element-74">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 text-left hover:bg-white/5 transition-colors" data-id="element-75">
        <span className="font-bold text-white text-lg" data-id="element-76">{question}</span>
        <ChevronDown className={`text-brand-yellow transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-77" />
      </button>
      <AnimatePresence data-id="element-78">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-79">
            <div className="p-5 pt-0 text-gray-300 leading-relaxed border-t border-gray-800/50" data-id="element-80">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}